import script from "./TopWorkbookPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopWorkbookPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopWorkbookPanel.vue?vue&type=style&index=0&id=61e47958&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e47958"]])

export default __exports__